import { clsx } from 'clsx';

interface ButtonCaptionProps {
  text?: string;
  className?: string;
}
export function ButtonCaption({
  text,
  className = 'max-w-[320px]',
}: ButtonCaptionProps) {
  if (!text) {
    return null;
  }
  return (
    <p className={clsx('text-black body-small mt-4', className)}>{text}</p>
  );
}
